import apiRequest from '@/http/api-request'
import {getToken} from "@/utils/api";

export default {
  fetchLists({commit, state}, {charityId}) {

    if ((parseInt((new Date().getTime() / 1000)) - state.lastUpdate) < 3600 //1 hour cache
    ) {
      return new Promise((resolve) => resolve(state.donors));
    }

    return new Promise((resolve, reject) => {
      return apiRequest.doGetRequest(`/charity/${charityId}/lists/`,
        {}, {'X-Harness-JWT': getToken()}, {skipCache: true})
        .then(lists => {
          commit('SET_LISTS', lists);
          resolve(lists);
        })
        .catch((error) => reject(error));
    });
  },
}
